import { Button } from '@/components/ui/Button';

type RoleActionButtonProps = {
  label: string;
  icon: string;
  iconAlt: string;
  variant: 'primary' | 'secondary';
  onClick: () => void;
};

export default function RoleActionButton({ label, icon, iconAlt, variant, onClick }: RoleActionButtonProps) {
  return (
    <Button onClick={onClick} variant={variant}>
      <img src={icon} alt={iconAlt} className="w-6 h-6" />
      {label}
    </Button>
  );
}
